import { Cell } from './table';
import { LIST_USAGE_TYPE, TABLE_COLUMNS } from './constants';
import { ListReference } from '../../domain';

type ListReferenceTypeCellProps = {
  listReference: ListReference;
  rowIndex: number;
};

const TYPE_CELL_DATA_TEST = 'list-usage-type-cell';
const TYPE_TEXT_DATA_TEST = 'list-usage-type-text';

export const ListReferenceTypeCell = ({
  listReference: dependent,
  rowIndex,
}: ListReferenceTypeCellProps) => (
  <Cell data-test={TYPE_CELL_DATA_TEST} columnId={TABLE_COLUMNS.TYPE} rowIndex={rowIndex}>
    <div data-test={TYPE_TEXT_DATA_TEST}>{LIST_USAGE_TYPE[dependent.__typename]}</div>
  </Cell>
);
